import React from 'react';
import ManageRentals from '../../Landlord/components/ManageRentals';

const Units = () => <ManageRentals propertyScope="bnb" />;

export default Units;
